// removed by extract-text-webpack-plugin
module.exports = {"step":"Estado__step___1C5xm","textoConTooltip":"Estado__textoConTooltip___2J1Ua","tooltip":"Estado__tooltip___1Bj5H","tooltiptext":"Estado__tooltiptext___3DARU"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/nominas/nominaIG/components/Estado.css
// module id = 927
// module chunks = 0